'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cycler = exports.getPropertyValue = exports.scrollToElem = exports.easingEquations = exports.matchBreakpoint = exports.mediaBreakpointMatches = exports.mediaBreakpoints = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.externalLinks = externalLinks;
exports.wrapTables = wrapTables;
exports.wrapIframes = wrapIframes;
exports.getOffsetTop = getOffsetTop;
exports.getOffsetLeft = getOffsetLeft;
exports.scrollToY = scrollToY;
exports.debounce = debounce;
exports.slideDown = slideDown;
exports.slideUp = slideUp;
exports.faviconTheme = faviconTheme;

var _functional = require('./functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * This ensures all links to external sites are _blank'd and have the relevant rel properties set
 */
function externalLinks() {
  var links = (0, _functional.getElements)('a');

  // If the link starts with any of these things, we'll open a 600x300 popup
  // window for them.
  var usePopupPrefixes = ['https://twitter.com/intent/tweet?', 'https://www.facebook.com/sharer.php?', 'https://www.linkedin.com/shareArticle?'];

  var thisDomain = window.location.hostname.indexOf('www.') === 0 ? window.location.hostname.substr(4) : window.location.hostname;

  links.forEach(function (link) {
    var href = link.getAttribute('href');

    if (!href || href.indexOf('mailto:') >= 0 || (0, _functional.doesStringContainAny)(href, ['http://', 'https://', '//']) === false) {
      return;
    }

    var domain = link.hostname.indexOf('www.') === 0 ? link.hostname.substr(4) : link.hostname;

    if (domain !== thisDomain) {
      link.setAttribute('target', '_blank');
      // Add noopener and 'noreferrer' to work around this:
      // https://dev.to/ben/the-targetblank-vulnerability-by-example
      var rel = link.getAttribute('rel');

      if (!rel) {
        // will be null if it is not set
        rel = '';
      }

      link.setAttribute('rel', rel + ' noopener noreferrer');
    }

    // Use a popup for social sharing links.
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(usePopupPrefixes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prefix = _step.value;

        if (href.indexOf(prefix) === 0) {
          link.addEventListener('click', function (event) {
            event.preventDefault();
            window.open(href, '_blank', 'width=600,height=300,menubar=0,toolbar=0,status=0');
          });

          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  });
}

/**
 * This wraps all of the tables inside rich text areas so we can perform responsive styles easier
 *
 * @param {Array} elements - The tables we want to wrap
 * @param {String} [wrapClass=rte-RichText_Table] - The class name we want to use on the wrapping elements
 */
/*
 External links (defined as all links pointing to a domain that is not the
 same as the one from which the current document is being served)
 will have their 'target' attribute set to '_blank'.
 Social media sharing links will show in a popup.
 */
function wrapTables() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$elements = _ref.elements,
      elements = _ref$elements === undefined ? [] : _ref$elements,
      _ref$wrapClass = _ref.wrapClass,
      wrapClass = _ref$wrapClass === undefined ? 'rte-RichText_Table' : _ref$wrapClass;

  elements.forEach(function (el) {
    var div = (0, _functional.createElement)('div', {
      class: wrapClass
    });
    div.innerHTML = el.outerHTML;
    el.parentNode.insertBefore(div, el);
    el.remove();
  });
}

/**
 * This wraps all of the iframes inside rich text areas so we can perform responsive styles easier
 *
 * @param {Array} elements - The iframes we want to wrap
 * @param {String} [wrapClass=rte-RichText_Iframe] - The class name we want to use on the wrapping elements
 */
function wrapIframes() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$elements = _ref2.elements,
      elements = _ref2$elements === undefined ? [] : _ref2$elements,
      _ref2$wrapClass = _ref2.wrapClass,
      wrapClass = _ref2$wrapClass === undefined ? 'rte-RichText_Iframe' : _ref2$wrapClass;

  elements.forEach(function (el) {
    var div = (0, _functional.createElement)('div', {
      class: wrapClass
    });
    div.innerHTML = el.outerHTML;
    el.parentNode.insertBefore(div, el);
    el.remove();

    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    var newIframe = (0, _functional.getElement)('iframe', div);
    newIframe.setAttribute('src', newIframe.getAttribute('src'));
  });
}

/*
 Media breakpoints
 */
var mediaBreakpoints = exports.mediaBreakpoints = {
  xs: 480,
  sm: 768,
  md: 900,
  lg: 1200,
  xlg: 1440,
  xxlg: 1600

  /**
   * Checks if current window size matches specified breakpoint
   *
   * @param {String} mediaBreakpoint - The media breakpoint to match
   */
};var mediaBreakpointMatches = exports.mediaBreakpointMatches = function mediaBreakpointMatches(mediaBreakpoint) {
  switch (mediaBreakpoint) {
    case 'xs':
      return window.innerWidth < mediaBreakpoints.sm;
    case 'sm':
      return window.innerWidth >= mediaBreakpoints.sm && window.innerWidth < mediaBreakpoints.md;
    case 'md':
      return window.innerWidth >= mediaBreakpoints.md && window.innerWidth < mediaBreakpoints.lg;
    case 'lg':
      return window.innerWidth >= mediaBreakpoints.lg && window.innerWidth < mediaBreakpoints.xlg;
    case 'xlg':
      return window.innerWidth >= mediaBreakpoints.xlg && window.innerWidth < mediaBreakpoints.xxlg;
    case 'xxlg':
      return window.innerWidth >= mediaBreakpoints.xxlg;
  }
};

/**
 * Checks to see if the viewport matches the desired media breakpoint
 *
 * @param {String} breakpoint - The breakpoint we want to match
 * @param {String} [direction=down] - The direction where to match, up will match all breakpoints that are larger than the one specified, and down will match all breakpoints below the one specified
 */
var matchBreakpoint = exports.matchBreakpoint = function matchBreakpoint(breakpoint) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'down';

  if (direction === 'up') {
    if (window.innerWidth >= mediaBreakpoints[breakpoint]) {
      return true;
    }
  } else {
    if (window.innerWidth <= mediaBreakpoints[breakpoint]) {
      return true;
    }
  }

  return false;
};
/**
 * Gets the offsetTop of the passed element relevant to it's offsetParent
 *
 * @param {HTMLElement|Element} el - The element we'll be getting the offsetTop for
 * @param {Document|HTMLElement} [parent=HTMLBodyElement] - The offsetParent we want to get the offsetTop relative to
 * @param {Number} [offsetTop=0] - The starting offsetTop. This tends to be 0 but given this is a
 *   recursive function, we need to pass it to let it build up
 *
 * @returns {Number}
 */
function getOffsetTop(el) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  var offsetTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (!isNaN(el.offsetTop)) {
    offsetTop += el.offsetTop;
  }

  return el.offsetParent === parent ? offsetTop : getOffsetTop(el.offsetParent, parent, offsetTop);
}

/**
 * Gets the offsetLeft of the passed element relevant to it's offsetParent
 *
 * @param {HTMLElement|Element} el - The element we'll be getting the offsetLeft for
 * @param {Document|HTMLElement} [parent=HTMLBodyElement] - The offsetParent we want to get the offsetLeft relative to
 * @param {Number} [offsetLeft=0] - The starting offsetLeft. This tends to be 0 but given this is a
 *   recursive function, we need to pass it to let it build up
 *
 * @returns {Number}
 */
function getOffsetLeft(el) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  var offsetLeft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (!isNaN(el.offsetLeft)) {
    offsetLeft += el.offsetLeft;
  }

  return el.offsetParent === parent ? offsetLeft : getOffsetLeft(el.offsetParent, parent, offsetLeft);
}

var easingEquations = exports.easingEquations = {
  easeOutSine: function easeOutSine(pos) {
    return Math.sin(pos * (Math.PI / 2));
  },
  easeInOutSine: function easeInOutSine(pos) {
    return -0.5 * (Math.cos(Math.PI * pos) - 1);
  },
  easeInOutQuint: function easeInOutQuint(pos) {
    if ((pos /= 0.5) < 1) {
      return 0.5 * Math.pow(pos, 5);
    }
    return 0.5 * (Math.pow(pos - 2, 5) + 2);
  }
};

/**
 * This scrolls down to a specified point using a bezier curve
 *
 * @param {Number} scrollTargetY - Where we want the scroll to finish
 * @param {Function} callback - A callback function to execute after finishing the scroll
 * @param {Number} [speed=300] - In all honesty, not sure what this controls even though it says speed..
 * @param {String} [easing=easeInOutQuint] - The type of bezier curve we want to use
 *
 * @returns {Promise}
 */
function scrollToY() {
  var scrollTargetY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var callback = arguments[1];
  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'easeInOutQuint';

  // eslint-disable-next-line compat/compat
  var scrollY = window.scrollY || window.pageYOffset;
  var currentTime = 0;

  var time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8));

  function tick() {
    currentTime += 1 / 60;

    var position = currentTime / time;
    var t = easingEquations[easing](position);

    if (position < 1) {
      window.requestAnimationFrame(tick);

      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  }

  tick();

  // if ( typeof callback === 'function' ) {
  //   setTimeout(() => {
  //     callback()
  //   }, speed + 1)
  // }
}

/**
 * Scrolls to a particular element in the page, taking into account the header size
 *
 * @param {HTMLElement} elem - The reference element to scroll to
 * @param {Number} [offset=0] - Offset distance from origin
 * @param {Function} callback - A callback function to execute after finishing the scroll
 */
var scrollToElem = exports.scrollToElem = function scrollToElem(elem) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var callback = arguments[2];

  // eslint-disable-next-line compat/compat
  var scrollY = window.scrollY || window.pageYOffset;
  var headerHeight = parseInt(getPropertyValue('--Visible_Header_Height'));
  var distanceFromTop = elem.getBoundingClientRect().top;

  scrollToY(scrollY + distanceFromTop - headerHeight + offset, callback);
};

/**
 * Gets property value from element
 *
 * @param {String} propertyName - The name of the property
 * @param {HTMLElement} [elem=document.body] - The element to get the property from
 *
 * @returns {String}
 */
var getPropertyValue = exports.getPropertyValue = function getPropertyValue(propertyName) {
  var elem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

  var style = getComputedStyle(elem);

  return style.getPropertyValue(propertyName);
};

/**
 * Creates a class we can use to cycle through items in sequential order
 */

var Cycler = exports.Cycler = function () {
  function Cycler(items) {
    (0, _classCallCheck3.default)(this, Cycler);

    this.items = items;
    this.currentPosition = 0;
  }

  (0, _createClass3.default)(Cycler, [{
    key: 'current',
    value: function current() {
      return this.items[this.currentPosition];
    }
  }, {
    key: 'set',
    value: function set(val) {
      this.currentPosition = val;
    }
  }, {
    key: 'prev',
    value: function prev() {
      var current = this.current();
      this.currentPosition = this.currentPosition - 1;

      if (this.currentPosition < 0) this.currentPosition = this.items.length - 1;

      return current;
    }
  }, {
    key: 'next',
    value: function next() {
      var current = this.current();
      this.currentPosition = (this.currentPosition + 1) % this.items.length;

      return current;
    }
  }]);
  return Cycler;
}();

/**
 * Ensures a function doesn't run more than 1 per {wait}ms
 *
 * @param {Function} func - The function we'll be running
 * @param {Number} wait - How long to wait until running the function again
 * @param {Boolean} [immediate=false] - If `immediate` is passed, trigger the function on the leading edge,
 *   instead of the trailing.
 *
 * @returns {Number}
 */

function debounce(func, wait) {
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var timeout = void 0;

  return function () {
    var context = this;
    var args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/**
 * A vanilla equivalent of jquery's $(el).slideDown()
 *
 * @param {HTMLElement|Element} el - The element we'll be animating
 * @param {Number} end - The number we want to end the slide at
 * @param {Number} [start=0] - Where we want to start the slide from, normally 0
 * @param {String} [easing=easeInOutQuint] - The type of bezier curve we want to use
 * @param {Number} [speed=300] - How long we want the animation to take..ish?
 *
 * @returns {Promise}
 */
function slideDown(el, end) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$start = _ref3.start,
      start = _ref3$start === undefined ? 0 : _ref3$start,
      _ref3$easing = _ref3.easing,
      easing = _ref3$easing === undefined ? 'easeInOutQuint' : _ref3$easing,
      _ref3$speed = _ref3.speed,
      speed = _ref3$speed === undefined ? 300 : _ref3$speed;

  var currentPosition = 0;
  var time = Math.max(0.1, Math.min(Math.abs(end) / speed, 0.8));

  return new _promise2.default(function (resolve, reject) {
    var tick = function tick() {
      currentPosition += 1 / 60;
      var position = currentPosition / time;
      var t = easingEquations[easing](position);

      if (position < 1) {
        window.requestAnimationFrame(tick);

        el.style.height = currentPosition + (end - currentPosition) * t + 'px';
      } else {
        el.style.height = end + 'px';

        resolve();
      }
    };

    tick();
  });
}

/**
 * A vanilla equivalent of jquery's $(el).slideUp()
 *
 * @param {HTMLElement|Element} el - The element we'll be animating
 * @param {Number} start - Where we want to start the slide from, normally 0
 * @param {Number} [end=0] - The number we want to end the slide at
 * @param {String} [easing=easeInOutQuint] - The type of bezier curve we want to use
 * @param {Number} [speed=300] - How long we want the animation to take..ish?
 *
 * @returns {Promise}
 */
function slideUp(el, start) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref4$end = _ref4.end,
      end = _ref4$end === undefined ? 0 : _ref4$end,
      _ref4$easing = _ref4.easing,
      easing = _ref4$easing === undefined ? 'easeInOutQuint' : _ref4$easing,
      _ref4$speed = _ref4.speed,
      speed = _ref4$speed === undefined ? 300 : _ref4$speed;

  var currentPosition = 0;
  var time = Math.max(0.1, Math.min(Math.abs(start) / speed, 0.8));
  var easingEquations = {
    easeOutSine: function easeOutSine(t) {
      return Math.sin(t * (Math.PI / 2));
    },
    easeInOutSine: function easeInOutSine(t) {
      return -0.5 * (Math.cos(Math.PI * t) - 1);
    },
    easeInOutQuint: function easeInOutQuint(t) {
      return (t /= 0.5) < 1 ? 0.5 * Math.pow(t, 5) : 0.5 * (Math.pow(t - 2, 5) + 2);
    }
  };

  return new _promise2.default(function (resolve, reject) {
    var tick = function tick() {
      currentPosition += 1 / 60;
      var position = currentPosition / time;
      var t = easingEquations[easing](position);

      if (position < 1) {
        window.requestAnimationFrame(tick);

        el.style.height = start - (start - end) * t + 'px';
      } else {
        el.style.height = end + 'px';

        resolve();
      }
    };

    tick();
  });
}

/**
 * This changes the favicon depending on the OS colour scheme
 */
function faviconTheme() {
  var link = document.createElement('link');
  var head = document.head;
  link.setAttribute('rel', 'shortcut favicon icon');
  head.appendChild(link);

  if (matchMedia('(prefers-color-scheme: dark)').matches) {
    var source = (0, _functional.getElement)('link[media="(prefers-color-scheme: dark)"]');
    var faviconToRemove = (0, _functional.getElement)('link[media="(prefers-color-scheme: light)"]');

    if (source === null) {
      return;
    }

    link.setAttribute('type', source.type);
    link.setAttribute('href', source.href);
    faviconToRemove.parentNode.removeChild(faviconToRemove);
  } else {
    var _source = (0, _functional.getElement)('link[media="(prefers-color-scheme: light)"]');
    var _faviconToRemove = (0, _functional.getElement)('link[media="(prefers-color-scheme: dark)"]');

    if (_source === null) {
      return;
    }

    link.setAttribute('type', _source.type);
    link.setAttribute('href', _source.href);
    _faviconToRemove.parentNode.removeChild(_faviconToRemove);
  }
}